export default "__VITE_ASSET__09f71694__"